import { Box, withStyles } from '@material-ui/core';
import { purple } from 'globals/colors';

export const MainBoardBox = withStyles(({ palette, spacing, breakpoints }) => ({
  root: {
    background: purple.V2,
    borderRadius: 10,
    color: palette.common.white,
    padding: spacing(3),
    marginBottom: spacing(3),

    [breakpoints.up('sm')]: {
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
    },

    [breakpoints.up('md')]: {
      padding: spacing(0, 5),
    },

    '& h1': {
      marginBottom: spacing(2),
    },
  },
}))(Box);

export const InfoWrapper = withStyles(({ spacing, breakpoints }) => ({
  root: {
    [breakpoints.up('sm')]: {
      paddingRight: spacing(2),
    },
    [breakpoints.up('sm')]: {
      padding: spacing(2, 2, 2, 0),
    },
  },
}))(Box);

export const ImageWrapper = withStyles(({ breakpoints, spacing }) => ({
  root: {
    width: '100%',
    textAlign: 'center',
    marginBottom: spacing(2),
    '& svg': {
      width: '100%',
      maxWidth: 352,
      minWidth: 250,
      height: 'auto',
    },
    [breakpoints.up('sm')]: {
      marginBottom: 0,
    },
    [breakpoints.up('md')]: {
      '& svg': {
        minWidth: 270,
        transform: `translateY(40px)`,
      },
    },
  },
}))(Box);
